import { render, staticRenderFns } from "./overview-header.vue?vue&type=template&id=d6e85550&"
import script from "./overview-header.vue?vue&type=script&lang=js&"
export * from "./overview-header.vue?vue&type=script&lang=js&"
import style0 from "./overview-header.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports